module.exports = __webpack_public_path__ + "rosacea_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_3_before.jpg
// module id = 982
// module chunks = 0